import { useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { IconHourglass, IconCheckCircleFilled } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import UploadGewerbescheinModal from './UploadGewerbescheinActionModals';
import StepItem from '../stepItem/StepItem';

const StepAction = ({
    status,
    setModalOpen
}: {
    status: string;
    setModalOpen: (modalOpen: boolean) => void;
}) => {
    return status === 'PENDING' ? (
        <div className="px-l py-s min-sm:py-0">
            <IconHourglass
                height="24"
                width="24"
                fill="rgba(0, 77, 51, 1)"
                xlinkTitle="checked"
            />
        </div>
    ) : status === 'COMPLETED' ? (
        <div>
            <IconCheckCircleFilled
                data-testid="completed-action-icon"
                height="24"
                width="24"
                fill="rgba(0, 77, 51, 1)"
                xlinkTitle="checked"
            />
        </div>
    ) : (
        <Button
            onClick={() => {
                tracking.ampli.fundingStepCtaClicked({
                    funding_step: 'Upload Gewerbeschein'
                });
                setModalOpen(true);
            }}
            variant="primary"
        >
            <FormattedMessage
                id="_.funding_requirements.upload_gewerbeschein_button"
                defaultMessage="Upload"
            />
        </Button>
    );
};
export const UploadGewerbescheinAction = ({
    status,
    triggerRefetchFundingRequirements
}: {
    status: string;
    triggerRefetchFundingRequirements: () => void;
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleModalClose = () => {
        setIsModalOpen(false);
        triggerRefetchFundingRequirements();
    };

    return (
        <>
            <StepItem
                title={
                    <FormattedMessage
                        id="_.funding_requirements.upload_gewerbeschein_title"
                        defaultMessage="Your Gewerbeschein"
                    />
                }
                caption={
                    status === 'PENDING' ? (
                        <FormattedMessage
                            id="_.funding_requirements.upload_gewerbeschein_caption_doc_recieved"
                            defaultMessage="We have received your file. Please wait until we have reviewed your information and marked this step as 'Complete'."
                        />
                    ) : (
                        <FormattedMessage
                            id="_.funding_requirements.upload_gewerbeschein_caption"
                            defaultMessage="Upload your trade licence as a PDF (max. 50 MB)"
                        />
                    )
                }
                action={
                    <StepAction status={status} setModalOpen={setIsModalOpen} />
                }
            />
            <UploadGewerbescheinModal
                isOpen={isModalOpen}
                onClose={handleModalClose}
            />
        </>
    );
};
